const x = {
  min: "12px",
  sm: "14px",
  base: "16px",
  lg: "18px",
  xl: "20px",
  "2xl": "22px",
  "3xl": "24px",
  "4xl": "32px",
  "5xl": "44px",
  "6xl": "56px",
  "7xl": "64px",
  "8xl": "72px",
  "9xl": "80px",
  "10xl": "96px",
  max: "120px"
}, a = {
  thin: "100",
  extraLight: "200",
  light: "300",
  normal: "400",
  medium: "500",
  semiBold: "600",
  bold: "700",
  extraBold: "800",
  black: "900",
  extraBlack: "950"
}, l = {
  campaign: "'Barlow Condensed', Arial Narrow, sans-serif",
  sans: "'Interstate', Helvetica, Arial, Verdana, sans-serif",
  serif: "'Crimson Pro', Georgia, serif",
  mono: "monospace"
};
export {
  l as family,
  x as size,
  a as weight
};
//# sourceMappingURL=font.js.map
